import { render, staticRenderFns } from "./eventIntroductionManage.vue?vue&type=template&id=0b63e9cd&scoped=true&"
import script from "./eventIntroductionManage.vue?vue&type=script&lang=ts&"
export * from "./eventIntroductionManage.vue?vue&type=script&lang=ts&"
import style0 from "./eventIntroductionManage.vue?vue&type=style&index=0&id=0b63e9cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b63e9cd",
  null
  
)

export default component.exports